module.exports = __webpack_public_path__ + "img/i_key_06.90eeb6ef.svg";